var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaRulerVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3411_2297",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333984,
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3411_2297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33398 3.16671C4.33398 2.80004 4.46454 2.48615 4.72565 2.22504C4.98676 1.96393 5.30065 1.83337 5.66732 1.83337L11.0007 1.83337C11.3673 1.83337 11.6812 1.96393 11.9423 2.22504C12.2034 2.48615 12.334 2.80004 12.334 3.16671L12.334 13.8334C12.334 14.2 12.2034 14.5139 11.9423 14.775C11.6812 15.0362 11.3673 15.1667 11.0007 15.1667L5.66732 15.1667C5.30065 15.1667 4.98676 15.0362 4.72565 14.775C4.46454 14.5139 4.33398 14.2 4.33398 13.8334L4.33398 3.16671ZM5.66732 3.16671L5.66732 13.8334L11.0007 13.8334L11.0007 11.8334L8.33398 11.8334L8.33398 10.5L11.0007 10.5L11.0007 9.16671L8.33398 9.16671L8.33398 7.83337L11.0007 7.83337L11.0007 6.50004L8.33398 6.50004L8.33398 5.16671L11.0007 5.16671L11.0007 3.16671L5.66732 3.16671Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaRulerVertical);
export default __webpack_public_path__ + "static/media/FaRulerVertical.046ba44810ae9a99f5ab3c4761236fb7.svg";
export { ForwardRef as ReactComponent };